import { createContext, type PropsWithChildren, useContext } from "react";

export interface WorkoutItemActionsHandler {
  duplicate: () => Promise<void>;
  delete: () => Promise<void>;
  saveAsSection?: () => Promise<void>;
  unlink?: () => Promise<void>;
  canUnlink: boolean;
}

export interface WorkoutItemActionsContextValue {
  handler: WorkoutItemActionsHandler;
}

export const workoutItemActionsContext =
  createContext<WorkoutItemActionsContextValue>(null!);

export function useWorkoutItemActionsHandler() {
  return useContext(workoutItemActionsContext).handler;
}

export interface WorkoutItemActionsProviderProps extends PropsWithChildren {
  workoutItemId: string;
}

export interface WorkoutItemActionsProps {}
